// All editable business content lives here for easy maintenance.
export const business = {
  name: "Pristine Water Systems",
  region: "Sunshine Coast",
  phone: "(07) 5238 8182",
  phoneHref: "tel:+61752388182",
  email: "teamnoosa@pristinewater.net.au",
  address: "Unit 1/37 Gateway Drive, Noosaville QLD 4566",
  hours: "Monday to Friday, 8:00 am–4:00 pm",
};

export const nav = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Why Pristine", href: "#why" },
  { label: "Service Area", href: "#area" },
  { label: "Contact", href: "#contact" },
];

export const marqueeItems = [
  "Rainwater Tank Cleaning",
  "Whole-of-House Filtration",
  "UV Disinfection",
  "BioCleanse Pipework",
  "Water Testing",
  "Bore Water Treatment",
  "Filtration Servicing",
  "Complete Water Care",
];

export const services = [
  {
    id: "tank-cleaning",
    title: "Rainwater Tank Cleaning",
    body: "Our QuadClean™ tank cleaning process removes built-up sediment and organic material from the bottom of your tank while retaining most of your stored water.",
    cta: "Learn About Tank Cleaning",
    icon: "Droplets",
    featured: true,
  },
  {
    id: "filtration",
    title: "Whole-of-House Water Filtration",
    body: "Custom filtration systems designed around your property, water source, water usage and treatment requirements.",
    cta: "Get a Filtration Recommendation",
    icon: "Filter",
  },
  {
    id: "biocleanse",
    title: "BioCleanse Pipework Treatment",
    body: "A professional pipework disinfection service designed to address biofilm and contamination within household water lines.",
    cta: "Book a BioCleanse Assessment",
    icon: "Waves",
  },
  {
    id: "uv",
    title: "UV Water Disinfection",
    body: "UV systems provide an additional barrier against microorganisms without adding chemicals to your drinking water.",
    cta: "Ask About UV Protection",
    icon: "Sun",
  },
  {
    id: "testing",
    title: "Water Testing",
    body: "Laboratory water testing helps identify what is present in your water and provides clearer guidance on the treatment or maintenance your property may require. Testing completed by AWARE Water Testing.",
    cta: "Arrange Water Testing",
    icon: "FlaskConical",
  },
  {
    id: "bore",
    title: "Bore Water Treatment",
    body: "Practical treatment solutions for common bore water issues, including iron, sediment, staining, odour, hardness and water chemistry concerns.",
    cta: "Discuss Your Bore Water",
    icon: "Mountain",
  },
  {
    id: "servicing",
    title: "Filtration Servicing",
    body: "Cartridge replacement, UV lamp servicing, quartz sleeve cleaning and complete filtration system inspections.",
    cta: "Book a System Service",
    icon: "Wrench",
  },
];

export const flowSteps = [
  "Roof Catchment", "Tank", "Pump", "Pipework", "Filtration", "UV", "Household",
];

export const whyPoints = [
  "Experienced local water system specialists",
  "Practical recommendations based on your property",
  "Complete tank, filtration, UV and pipework solutions",
  "Professional equipment and proven service processes",
  "Clear explanations without unnecessary technical jargon",
  "Ongoing servicing and maintenance support",
  "Laboratory testing available through AWARE Water Testing",
  "Servicing homes across Noosa, Maroochydore and the Sunshine Coast",
];

export const processSteps = [
  { n: "01", title: "Tell Us About Your Water", body: "Complete the enquiry form or call our local team." },
  { n: "02", title: "We Assess Your Property", body: "We discuss your water source, system, concerns and maintenance history." },
  { n: "03", title: "You Receive Clear Recommendations", body: "We explain what needs attention and provide practical treatment or servicing options." },
  { n: "04", title: "We Complete the Work", body: "Our technicians carry out the approved work and explain how to maintain the system moving forward." },
];

export const serviceAreas = [
  "Noosa", "Noosaville", "Tewantin", "Peregian", "Coolum", "Maroochydore",
  "Buderim", "Eumundi", "Cooroy", "Pomona", "Sunshine Coast hinterland", "Surrounding areas",
];

export const testimonials = [
  {
    quote: "We have used Pristine Water for many years now and have always found their service excellent. Always on time. Would recommend them for your water tank service.",
    name: "Malcolm Condon",
    location: "Doonan",
  },
  {
    quote: "We were delighted with the great service provided by Pristine Water Systems for our whole-of-house water system. From the flawless initial installation to our recent first service, their team has been a pleasure to deal with — demonstrating outstanding communication, friendliness, and prompt punctuality. Both the quality of the filtration system itself and their professional workmanship offer truly excellent value.",
    name: "Shane Bunter",
    location: "Federal",
  },
  {
    quote: "Couldn't be happier with Pristine Water Systems. They cleaned out our tank, disinfected the house pipes, and installed a two-stage plus UV filtration system — all in a single day. Professional, thorough, and great to deal with from start to finish.",
    name: "Nick Barton",
    location: "Tinbeerwah",
  },
];

export const faqs = [
  {
    q: "How often should a rainwater tank be cleaned?",
    a: "Some properties require more frequent servicing, while others may only need cleaning every three to five years. It depends on the property location, roof catchment, surrounding vegetation, gutter maintenance and the amount of sediment entering the tank.",
  },
  {
    q: "Will I lose all the water in my tank?",
    a: "No. Our QuadClean™ process is designed to remove sediment and organic material from the bottom of your tank while retaining most of your stored water.",
  },
  {
    q: "Do you provide water testing?",
    a: "Yes. Laboratory water testing is available through AWARE Water Testing to help identify what is present in your water and guide any treatment or maintenance your property may require.",
  },
  {
    q: "Can you service my existing filtration system?",
    a: "Yes. We provide cartridge replacement, UV lamp servicing, quartz sleeve cleaning and complete filtration system inspections for most existing systems.",
  },
  {
    q: "Do I need UV treatment for tank water?",
    a: "It depends on your property and how the water is used. UV disinfection can provide an additional barrier against microorganisms without adding chemicals. We assess your system and explain your options clearly.",
  },
  {
    q: "Can you treat bore water problems?",
    a: "Yes. We offer practical treatment solutions for common bore water concerns such as iron, sediment, staining, odour, hardness and general water chemistry.",
  },
  {
    q: "What areas of the Sunshine Coast do you service?",
    a: "We service Noosa, Noosaville, Tewantin, Peregian, Coolum, Maroochydore, Buderim, Eumundi, Cooroy, Pomona, the Sunshine Coast hinterland and surrounding areas. Not sure if we cover your area? Call (07) 5238 8182.",
  },
  {
    q: "Can you inspect my full water system?",
    a: "Yes. We assess the complete water pathway — roof catchment, tank, pump, pipework, filtration and UV — and recommend practical improvements based on your property.",
  },
];

export const images = {
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/eswjp0af_pristine_water_systems_clear.png",
  heroHome: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/cl5b2atw_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2002_25_11%20PM.png",
  tankGarden: "https://static.prod-images.emergentagent.com/jobs/b3ee85a4-c83a-42b9-985b-fb274ee6d05d/images/64def4b26921b4ddf31a1b31d1d47e26483554f9b5dfea798a4a9dc96acd2051.png",
  serviceTech: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/0mc0r681_BradPike.webp",
  technician: "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  glassPour: "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  awareLogo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/w1s30mdj_ChatGPT%20Image%20Jul%2010%2C%202026%2C%2008_56_55%20PM.webp",
  uvBanner: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/4olhwpeu_image.png",
  biocleanseLogo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/jreffau0_image.png",
  filtrationTanks: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/bsefboxh_WOH.png",
  pipework: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=1200",
  faucet: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/a92c5fwn_removal3%20%281%29.jpeg",
  familyTap: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/u8wul0tt_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2003_53_25%20PM.png",
  ripple: "https://images.unsplash.com/photo-1535868118629-f37bcd69ff59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  coastline: "https://customer-assets-lxgj4vgw.emergentagent.net/job_clean-water-coast/artifacts/tc6qe38o_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2004_29_28%20PM.png",
};
